<template>
  <div>
    <div
      class="video"
      v-if="
        current_step !== '2' &&
        background_aa &&
        background_aa.type_media.slug == 'video'
      "
    >
      <video
        :style="register ? cssProps : {}"
        id="background-video"
        :autoplay="isPlaying"
        loop
        poster=""
        ref="backgroundVideo"
      >
        <source :src="background_aa.full_path" type="video/mp4" />
      </video>
      <div v-if="!isPlaying" class="play_button" @click="play()"></div>
      <div v-else class="stop_button" @click="stop()"></div>
    </div>
    <div
      class="video"
      v-if="
        current_step == '2' &&
        background &&
        background.type_media.slug == 'video'
      "
    >
      <video
        :style="register ? cssProps : {}"
        id="background-video"
        :autoplay="isPlaying"
        loop
        poster=""
        ref="backgroundVideo"
      >
        <source :src="background.full_path" type="video/mp4" />
      </video>
      <div v-if="!isPlaying" class="play_button" @click="play()"></div>
      <div v-else class="stop_button" @click="stop()"></div>
    </div>
    <div
      class="image"
      v-if="
        current_step !== '2' &&
        background_aa &&
        background_aa.type_media.slug == 'image'
      "
    >
      <img :src="background_aa.full_path" alt="" />
    </div>
    <div
      class="image test"
      v-if="
        current_step == '2' &&
        background &&
        background.type_media.slug == 'image'
      "
    >
      <img :src="background.full_path" alt="" />
    </div>
    <!-- <div
      :style="{ backgroundImage: `url(${background.full_path})` }"
      class="image"
      v-if="cover.type_media.slug == 'image'"
    ></div> -->
  </div>
</template>


<script>
var base_this;
export default {
  name: "LoginVideo",
  data() {
    return {
      isPlaying: false,
      cover: this.background
        ? this.background
        : {
            full_path: "",
            type_media: {
              slug: "",
            },
          },
    };
  },
  props: {
    background: {
      type: Object,
      default: {
        full_path: "",
        type_media: {
          slug: "",
        },
      },
    },
    background_aa: {
      type: Object,
      default: {
        full_path: "",
        type_media: {
          slug: "",
        },
      },
    },
    current_step: {
      type: "",
      default: "1",
    },
    register: {},
  },
  computed: {
    cssProps() {
      return { borderRadius: "30px 30px 0px 30px" };
    },
    media() {
      // var ok = window.getApp.item.media && window.getApp.item.media.type_media && (window.getApp.item.media.type_media.slug === 'video')
      var videoUrl = base_this.imagePath;
      return {
        sources: [
          {
            type:
              "video/" + videoUrl.split(".")[videoUrl.split(".").length - 1],
            src: videoUrl,
          },
        ],
        poster:
          "http://otd.test/storage/resources/OTD_BG_2021-02-11_04-25-45.jpeg",
      };
    },
    playerOptions() {
      return (media) => {
        return {
          // height: '360',
          loop: true,
          controls: true,
          fluid: true,
          autoplay: true,
          muted: false,
          language: "fr",
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: media.sources,
          //poster: media.poster,
        };
      };
    },
    getApp() {
      return window.getApp;
    },
  },
  watch: {
    current_step(val) {
      var video = document.getElementById("background-video");
      var source = document.createElement("source");
      if (
        this.background.type_media.slug == "video" &&
        this.background_aa.type_media.slug == "video"
      ) {
        video.pause();
      }
      source.setAttribute(
        "src",
        val == "1" ? this.background.full_path : this.background_aa.full_path
      );
      source.setAttribute("type", "video/mp4");
      if (
        this.background.type_media.slug == "video" &&
        this.background_aa.type_media.slug == "video"
      ) {
        video.load();
      }
    },
  },
  methods: {
    play() {
      this.$refs.backgroundVideo.play();
      // console.log("play");
      this.isPlaying = true;
    },
    stop() {
      this.$refs.backgroundVideo.pause();
      // console.log("stop");
      this.isPlaying = false;
    },
  },
  async created() {
    base_this = this;
  },
};
</script>

<style lang="scss">
.video {
  width: 60%;
  height: 444px;
  border-radius: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
}

@media (max-width: 1000px) {
  .video {
    width: 60%;
    // display: none;
  }
}

@media (max-width: 878px) {
  .video {
    width: 60%;
    // display: none;
  }
}
@media (max-width: 800px) {
  .video {
    width: 50%;
    // display: none;
  }
}

.image {
  // height: 514px;
  // border-radius: 30px;
  // position: relative;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  background-size: cover;

  width: 60%;
  height: 444px;
  border-radius: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
}
.image img {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
.play_button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  height: 74px;
  z-index: 2;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  border-style: solid;
  border-width: 37px 0px 37px 74px;
  border-color: transparent transparent transparent #ffcc00;
}
.stop_button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 70px;
  z-index: 2;
  position: relative;
  cursor: pointer;
  border-style: double;
  border-width: 0px 0px 0px 50px;
  border-color: #ffcc00;
}

#background-video {
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  z-index: 0;
  border-radius: 30px;
}
</style>
